/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteRetainerPeriodInput = {
    id?: string | null | undefined;
    projectId?: string | null | undefined;
    keepRollovers?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteRetainerPeriodMutationVariables = {
    input: DeleteRetainerPeriodInput;
};
export type deleteRetainerPeriodMutationResponse = {
    readonly deleteRetainerPeriod: {
        readonly deletedRetainerPeriodId: string | null;
    } | null;
};
export type deleteRetainerPeriodMutation = {
    readonly response: deleteRetainerPeriodMutationResponse;
    readonly variables: deleteRetainerPeriodMutationVariables;
};



/*
mutation deleteRetainerPeriodMutation(
  $input: DeleteRetainerPeriodInput!
) {
  deleteRetainerPeriod(input: $input) {
    deletedRetainerPeriodId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteRetainerPeriodInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRetainerPeriodPayload",
    "kind": "LinkedField",
    "name": "deleteRetainerPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedRetainerPeriodId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRetainerPeriodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRetainerPeriodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteRetainerPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRetainerPeriodMutation(\n  $input: DeleteRetainerPeriodInput!\n) {\n  deleteRetainerPeriod(input: $input) {\n    deletedRetainerPeriodId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c362ce68899dfa6fb14ec688d092b7be';
export default node;
